module.exports = __webpack_public_path__ + "nsettings_icon.svg";